import React from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default function APIDocsRoadmapsBlock() {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Roadmaps</div>
        <div className="text">
          A roadmap is a collection of posts. Posts can be associated with multiple roadmaps.
        </div>
        <div className="text">Roadmap data is exposed via API endpoints that fetch post data.</div>
      </div>
      <div />
    </APIDocsBlock>
  );
}
